<div fxLayout="row" fxFlex fxLayoutGap="10px grid" [ngStyle.xs]="{width: '100%'}">
  <div class="dx-field" fxLayout="column" fxLayoutAlign="space-between" fxFlex="calc(50% - 10px)">
    <div class="dx-field-label">From</div>
    <div style="width: 100%">
      <dx-date-box
        (ngModelChange)="handleChanges($event, startGroupControl)"
        [(max)]="endDate"
        [(ngModel)]="startDate"
        (onContentReady)="onContentReady($event)"
        type="date">
      </dx-date-box>
    </div>
  </div>

  <div class="dx-field" fxLayout="column" fxLayoutAlign="space-between" fxFlex="calc(50% - 10px)">
    <div class="dx-field-label">To</div>
    <div style="width: 100%">
      <dx-date-box
        (ngModelChange)="handleChanges($event, endGroupControl)"
        [(min)]="startDate"
        [(ngModel)]="endDate"
        (onContentReady)="onContentReady($event)"
        type="date">
      </dx-date-box>
    </div>
  </div>
</div>
